import React from "react";
import { Skeleton } from "primereact/skeleton";

const SideBarLoading: React.FC = () => {
    const skeletonCount = [3, 8, 3];

    return (
        <ul className="side_nav_list">
            {skeletonCount.map((count, index) => (
                <React.Fragment key={index}>
                    {Array.from({ length: count }).map((_, i) => (
                        <li key={i} className="sidebar_link_loading_item">
                            <Skeleton className="sidebar_link_loading" />
                        </li>
                    ))}
                    {index < skeletonCount.length - 1 && (
                        <hr className="border-secondary side_bar_divider" />
                    )}
                </React.Fragment>
            ))}
        </ul>
    )
}

export default SideBarLoading;